<template>
	<div>
		<projects-list
			:projects="this.projects"
			:supervisors="this.supervisors"
			:contest-id="this.$route.params.id"
			:secretary="isSecretary"
		></projects-list>
	</div>
</template>

<script>
	import ProjectsList from "./components/ProjectsList";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {User} from "@/api/generated/User";

	export default {
		name: "ContestProjectListView",
		components: {ProjectsList},
		data () {
			return {
				projects: [],
				supervisors: [],
				isSecretary: false,
			};
		},

		created () {
			loadContestProjects(this);
		},
	};

	function loadContestProjects (ctx) {
		PublicContest.getProjects(ctx, ctx.$route.params.id, response => {
			ctx.projects = response.sort((a, b) => b.projectCode.localeCompare(a.projectCode));
		});
		PublicContest.getIsSecretary(ctx, ctx.$route.params.id, response => ctx.isSecretary = response);
		User.getListSupervisors(ctx, ctx.$route.params.id, response => {
			ctx.supervisors = response;
			ctx.supervisors.forEach(supervisor => {
				ctx.$set(supervisor, "fullName", supervisor.name + " " + supervisor.surname);
			});
		});
	}
</script>

<style scoped>

</style>
